export default __webpack_public_path__ + "static/media/eform.ec8e5f37.jpg";